export class ChannelTemplateCategory {
  constructor(
    public id: number,
    public displayName: string,
  ) {}
}
